import { observable, action, flow } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';
import Serv from './LYLogisticsServ';

class LYLogisticsMod {
  // 订单号
  @observable tradeNo = '';

  // 发货单类型 枚举: ORDER_DELIVERY订货发货单、REPLENISH_DELIVERY欠货发货单
  @observable type = '';

  // 物流信息
  @observable info = [];

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 获取物流详情
   */
  getLogistics = flow(function* () {
    const { data } = yield Serv.getLogistics(this.tradeNo);
    this.info = data;
  });
}

export default LYLogisticsMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/OrderList/Detail/LYLogistics/LYLogisticsMod.js